import { Card } from '../../../../Components/Card'
import * as S from './styles'

export const CardSection = ({
  cards,
  title,
  text
}) => {
  return (
    <S.Wrapper>

      <S.TextBox>
        <h2>
          {title}
        </h2>
        <p>
          {text}
        </p>
      </S.TextBox>

      <S.CardBox>
        {
          cards.map((item, index) => (
            <S.CardWidth>
              <Card key={index} item={item} />
            </S.CardWidth>
          ))
        }
      </S.CardBox>
    </S.Wrapper>
  )
}
